import { render } from "./ChatsIcon.vue?vue&type=template&id=98e31e78"
import script from "./ChatsIcon.vue?vue&type=script&lang=js"
export * from "./ChatsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__